import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore extends BaseViewStore {
	@observable accessor isLoading = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.patientTemplates =  this.modalParams.data.patientTemplates;
    }

    @action.bound
    async deleteFacilityOrderTemplateItems() {
        this.isLoading = true;
        await this.modalParams.data.deleteItems();
        this.modalParams.close();
    }
}

export default NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore;
